import { render, staticRenderFns } from "./VehicletypeFields.vue?vue&type=template&id=06ff4080"
import script from "./VehicletypeFields.vue?vue&type=script&lang=js"
export * from "./VehicletypeFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports